import { render } from "./ManualDetailMac.vue?vue&type=template&id=1bd3592a&scoped=true"
import script from "./ManualDetailMac.vue?vue&type=script&lang=js"
export * from "./ManualDetailMac.vue?vue&type=script&lang=js"

import "./ManualDetailMac.vue?vue&type=style&index=0&id=1bd3592a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd3592a"]])

export default __exports__